<script setup>
import { ref, computed, onMounted } from "vue";
import { StealieDrawer, StealieText } from "@get-overalls/fe-stealie";
import { allCategories } from "@/services/RequestService";
import CategoryIcon from "./CategoryIcon.vue";

const props = defineProps({
  mode: {
    type: String,
    required: false,
    default: "custom",
    validator: (value) => ["custom", "explore"].includes(value),
  },
});

const isOpen = defineModel("open", { required: true, default: false, type: Boolean });
const categories = ref([]);
const heading = computed(() =>
  props.mode === "custom" ? "Custom request" : "Request categories",
);
const subheading = computed(() =>
  props.mode === "custom"
    ? "How would you categorize your request?"
    : "Explore request ideas from the following categories.",
);
onMounted(async () => {
  categories.value = await allCategories();
});
</script>

<template>
  <StealieDrawer v-model:open="isOpen" scrollable full-bleed dismissible data-sr-unmask>
    <section class="min-h-full bg-brand-primary-teal-highlight/18 p-6">
      <div class="mb-4 flex flex-col gap-y-4 px-6 py-4">
        <StealieHeading level="2" size="xl">{{ heading }}</StealieHeading>
        <StealieParagraph size="lg">{{ subheading }}</StealieParagraph>
      </div>
      <div class="mb-8 grid grid-cols-2 gap-4 px-6 sm:mb-0 sm:grid-cols-3">
        <template v-for="category in categories" :key="category.id">
          <RouterLink
            :to="`/requests/category/${category.id}`"
            class="flex flex-col items-center justify-center gap-8 rounded-lg border-2 border-brand-gray-50 bg-white px-4 py-6"
            @click="isOpen = false"
          >
            <div class="flex h-20 w-32 items-end justify-center">
              <CategoryIcon
                :src="category.image_url"
                :category="category.name"
                alt=""
                class="size-16"
              />
            </div>
            <div class="h-14 text-center">
              <StealieText class="text-brand-gray-600">{{ category.name }}</StealieText>
            </div>
          </RouterLink>
        </template>
      </div>
    </section>
  </StealieDrawer>
</template>
